// 发货模块的状态文案与颜色（文档 18 §4：5 色 + 灰，一行只一个实底标签）。
import type { TagTone } from '@/lib/status';

/** ShipmentStatus 只有 SHIPPED 一种：批次一建即出库 */
export const shipmentStatus: Record<string, { label: string; tone: TagTone }> = {
  SHIPPED: { label: '已出库', tone: 'green' },
};

export function shipmentStatusOf(v: string) {
  return shipmentStatus[v] || { label: v, tone: 'none' as TagTone };
}

/** 套装组件的用量规则：按套计灰底、按组计蓝底（文档 23 §11「每组用量 ≠ 每套用量」） */
export const ruleTone = { PER_SET: 'grey', PER_GROUP: 'blue' } as const;
